import { render, staticRenderFns } from "./KasBesarPiutang.vue?vue&type=template&id=412c7021"
import script from "./KasBesarPiutang.vue?vue&type=script&lang=js"
export * from "./KasBesarPiutang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports